export enum ProgramType {
  CACFP = "CACFP",
  SFSP = "SFSP"
}

export enum MealType {
  Breakfast = 1,
  Lunch = 3,
  SnackAM = 2,
  SnackPM = 4,
  Supper = 5,
  NonCongregate = 6
}


export enum Enviornments {
  Development = "Development",
  Test = "Test",
  Staging = "Staging",
  Production = "Production"
}
